module.exports = __webpack_public_path__ + "static/media/high-middle-3.ac33403c.png";